'use client';
import {FC, useEffect} from 'react';
import styles from './OrganizationInfoBlock.module.scss';
import { OrganizationInfo } from '@/models/OrganizationModels';
import Image from 'next/image';
import Verified from '../../app/assets/icons/verified.svg';
import { useTranslations } from 'next-intl';
import {useBackgroundImage} from "@/shared/BackgroundImageComponent/BackgroundImageProvider";
import VerificationPledge from "@/shared/VerificationPledge";

interface OrganizationInfoBlockProps {
  className?: string;
  statistic: OrganizationInfo;
}

const OrganizationInfoBlock: FC<OrganizationInfoBlockProps> = ({ className = '', statistic }) => {
  const t = useTranslations('ORGANIZATION_BLOCK');

  const { setImageUrl } = useBackgroundImage();

  useEffect(() => {
    const poster_image = `url(${statistic?.image || ''})`;
    setImageUrl(poster_image);
  }, [statistic, setImageUrl]);

  return (
    <div className={`${styles.root} ${className}`}>
      <Image className={styles.image} src={statistic.image} width={192} height={192} alt="image" />
      <div className={styles.info}>
        <h1 className={styles.title}>{statistic.name}</h1>
        <VerificationPledge is_verified={statistic?.is_verified} is_big={true}/>
      </div>

      <div className={styles.statistic}>
        <div className={styles.statistic__block}>
          <b>{statistic.active_events}</b>
          <p>{t('active')}</p>
        </div>

        <div className={styles.statistic__block}>
          <b>{statistic.held_events}</b>
          <p>{t('held')}</p>
        </div>

        <div className={styles.statistic__block}>
          <b>{statistic.member_amount}</b>
          <p>{t('gathered')}</p>
        </div>
      </div>
    </div>
  );
};

export default OrganizationInfoBlock;
